export const SimpleChatConfig = (chatbotData) => {
    return `(function () {
        function initChatbot() {
            try {
                const IFRAME_ID = "ameya-simple-chatbot-iframe";
                const existingIframe = document.getElementById(IFRAME_ID);
                if (existingIframe) existingIframe.remove();
                console.log("Chatbot ready to toggle...");

                window.toggleChatbot = (params = {}) => {
                    try {
                    
                        // START chatbotConfig
                        const chatbotConfig = ${JSON.stringify(chatbotData)}
                        // END chatbotConfig

                        let iframe = document.getElementById(IFRAME_ID);
                        
                        if (iframe) {
                            const isHidden = iframe.style.display === "none";
                            iframe.style.display = isHidden ? "block" : "none";
                            return;
                        }

                        iframe = document.createElement("iframe");
                        iframe.id = IFRAME_ID;
                        iframe.style.position = "fixed";
                        iframe.style.bottom = "0.5rem";
                        iframe.style.right = "1.5rem";
                        iframe.style.width = "70px";
                        iframe.style.height = "70px";
                        iframe.style.border = "none";
                        iframe.style.overflow = "hidden";
                        iframe.style.margin = "0";
                        iframe.style.padding = "0";
                        iframe.style.zIndex = "9999";
                        iframe.style.display = "block";
                        iframe.style.boxSizing = "border-box";
                        iframe.style.top = "auto";
                        iframe.style.left = "auto";
                        iframe.style.backgroundColor = "transparent";
                        iframe.style.background = "transparent";
                        iframe.setAttribute("allowTransparency", "true");
                        document.body.appendChild(iframe);

                        // Initialize iframe HTML structure
                        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                        iframeDoc.open();
                        iframeDoc.write(\`
                            <!DOCTYPE html>
                                <html>
                                    <head>
                                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                            <style>
                                                html, body {
                                                    margin: 0;
                                                    padding: 0;
                                                    height: 100%;
                                                    width: 100%;
                                                    overflow: hidden;
                                                    box-sizing: border-box;
                                                    display: flex;
                                                    flex-direction: column;
                                                    background-color: transparent !important;
                                                    background: transparent !important;
                                                }
                                                *, *::before, *::after {
                                                    box - sizing: inherit;
                                                }
                                                #root, #__next {
                                                    height: 100%;
                                                    width: 100%;
                                                    margin: 0;
                                                    padding: 0;
                                                    display: flex;
                                                    flex-direction: column;
                                                    background: transparent !important;
                                                }
                                            </style>
                                    </head>
                                    <body>
                                    </body>
                                </html>  \`);
                            
                            iframeDoc.close();

                            // Define destroy method (for close button)
                            iframe.contentWindow.parentDestroyChatbot = () => {
                                console.log("Destroying chatbot iframe...");
                                try {
                                    if (iframe.contentWindow && iframe.contentWindow.AmeayaChatBot) {
                                        iframe.contentWindow.AmeayaChatBot("destroy");
                                    }
                                    iframe.remove();
                                    console.log("Chatbot iframe removed.");
                                } catch (error) {
                                    console.error("Error during chatbot destroy:", error);
                                }
                            };

                        // Add chatbot script
                        iframe.onload = () => {
                            const script = document.createElement("script");
                            script.src = ${JSON.stringify(window.__ENV__.ANALYTICS_CHATBOT_PLUGIN_URL)}
                            script.async = true;

                            const userConfigs = { third_party_token_provider: null, third_party_token: null };
                            const externalCallbacks = window.__chatbotCallbacks || {};

                            const finalConfig = {
                                ...chatbotConfig, 
                                ...userConfigs,
                                ...externalCallbacks.extraConfig
                            };

                            script.onload = () => {
                                if (iframe.contentWindow.AmeayaChatBot) {
                                    iframe.contentWindow.AmeayaChatBot("init", finalConfig);
                                }
                                console.log("Chatbot initialized successfully.");
                            };

                            iframe.contentDocument.body.appendChild(script);
                                };
                    } 
                    catch (err) {
                        console.error("toggleChatbot error:", err);
                    }
                            
                }

                console.log("window.toggleChatbot() is ready. Call it to open/close the chatbot.");
                
                if (window.toggleChatbot) {
                    window.toggleChatbot();
                }
            } 
            catch (err) {
                console.error("Chatbot initialization failed:", err);
            }
        }

        // Initialize once DOM is ready
        if (document.readyState === "complete" || document.readyState === "interactive") {
            initChatbot();
        } else {
            document.addEventListener("DOMContentLoaded", initChatbot);
        }
    })()`
}

export const AdvancedChatConfig = (chatbotData) => {
    return `(function () {
                function initChatbot() {

                    console.log("Initializing chatbot...");

                    function cleanupExistingChatbot() {
                        const existingIframe = document.getElementById("ameya-chatbot-iframe");
                        const existingCloseBtn = document.getElementById("chatbot-close-btn");
                        if (existingIframe) existingIframe.remove();
                        if (existingCloseBtn) existingCloseBtn.remove();
                    }
                    cleanupExistingChatbot();

                    function handleCloseButton() {
                        const iframe = document.getElementById("ameya-chatbot-iframe");
                        const closeBtn = document.getElementById("chatbot-close-btn");
                        const chatBotButton = document.getElementById("chatBotButton");

                        if (iframe) iframe.style.display = "none";
                        if (closeBtn) closeBtn.style.display = "none";

                        if (chatBotButton) {
                            chatBotButton.style.display = "block";
                            console.log("Chatbot closed, button made visible");
                        }
                    }

                    window.toggleChatbot = (params) => {

                        // START chatbotConfig
                        const chatbotConfig = ${JSON.stringify(chatbotData)}
                        // END chatbotConfig

                        let iframe = document.getElementById("ameya-chatbot-iframe");
                        let closeBtn = document.getElementById("chatbot-close-btn");
                        const chatBotButton = document.getElementById("chatBotButton");

                        if (iframe && closeBtn) {
                            const isHidden = iframe.style.display === "none";
                            iframe.style.display = isHidden ? "block" : "none";
                            closeBtn.style.display = isHidden ? "block" : "none";

                            if (chatBotButton) {
                                chatBotButton.style.display = isHidden ? "none" : "block";
                            }
                            return;
                        }

                        if (chatBotButton) chatBotButton.style.display = "none";

                        iframe = document.createElement("iframe");
                        iframe.id = "ameya-chatbot-iframe";
                        iframe.style.position = "fixed";
                        iframe.style.top = "0";
                        iframe.style.left = "0";
                        iframe.style.width = "100vw";
                        iframe.style.height = "100vh";
                        iframe.style.border = "none";
                        iframe.style.zIndex = "9999";
                        iframe.style.display = "block";
                        document.body.appendChild(iframe);

                        closeBtn = document.createElement("button");
                        closeBtn.id = "chatbot-close-btn";
                        closeBtn.innerText = "✖";
                        closeBtn.style.position = "fixed";
                        closeBtn.style.top = "18px";
                        closeBtn.style.right = "20px";
                        closeBtn.style.color = "black";
                        closeBtn.style.border = "none";
                        closeBtn.style.borderRadius = "5px";
                        closeBtn.style.fontSize = "16px";
                        closeBtn.style.cursor = "pointer";
                        closeBtn.style.zIndex = "10000";
                        closeBtn.style.display = "block";
                        document.body.appendChild(closeBtn);

                        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                        const script = document.createElement("script");
                        script.src = ${JSON.stringify(window.__ENV__.ANALYTICS_CHATBOT_PLUGIN_URL)};
                        script.async = true;

                        function evalPlaceholder(expression) {
                            return new Function("params", \`return \${expression}\`)(params);
                        }

                        const userConfigs = {
                            "third_party_token_provider": evalPlaceholder('params?.token_provider ?? null'),
                            "third_party_token": evalPlaceholder('params?.third_party_token ?? null')
                        }

                        const externalCallbacks = window.__chatbotCallbacks || {};

                        const finalConfig = {
                            ...chatbotConfig, 
                            ...userConfigs,
                            ...externalCallbacks.extraConfig
                        };

                        script.onload = () => {
                            iframe.contentWindow.AmeayaChatBot?.("init", finalConfig);
                        };

                        iframeDoc.body.appendChild(script);
                    };

                    document.addEventListener("click", (event) => {
                        if (event.target.id === "chatbot-close-btn") {
                            handleCloseButton();
                        }
                    });

                }
                initChatbot();
            })()`
}

export const AdvancedChatPreview = async (chatbotData) => {
    return `(function () {
        function initChatbot() {
            function cleanupExistingChatbot() {
                const existingIframe = document.getElementById("ameya-advanced-chatbot-iframe");
                const existingCloseBtn = document.getElementById("chatbot-preview-close-btn");
                if (existingIframe) existingIframe.remove();
                if (existingCloseBtn) existingCloseBtn.remove();
            }
            cleanupExistingChatbot();

            function handleCloseButton() {
                const iframe = document.getElementById("ameya-advanced-chatbot-iframe");
                const closeBtn = document.getElementById("chatbot-preview-close-btn");
                const chatBotButton = document.getElementById("chatBotPreviewButton");

                if (iframe) iframe.remove();
                if (closeBtn) closeBtn.remove();

                if (chatBotButton) {
                    chatBotButton.style.display = "block";
                    console.log("Chatbot closed, button made visible");
                }
            }

            window.toggleChatbotPreview = (token_provider, third_party_token) => {
                let iframe = document.getElementById("ameya-advanced-chatbot-iframe");
                let closeBtn = document.getElementById("chatbot-preview-close-btn");
                const chatBotButton = document.getElementById("chatBotPreviewButton");

                if (iframe && closeBtn) {
                    const isHidden = iframe.style.display === "none";
                    iframe.style.display = isHidden ? "block" : "none";
                    closeBtn.style.display = isHidden ? "block" : "none";

                    if (chatBotButton) {
                        chatBotButton.style.display = isHidden ? "none" : "block";
                    }
                    return;
                }

                if (chatBotButton) chatBotButton.style.display = "none";

                iframe = document.createElement("iframe");
                iframe.id = "ameya-advanced-chatbot-iframe";
                iframe.style.position = "fixed";
                iframe.style.top = "0";
                iframe.style.left = "0";
                iframe.style.width = "100vw";
                iframe.style.height = "100vh";
                iframe.style.border = "none";
                iframe.style.zIndex = "9999";
                iframe.style.display = "block";
                document.body.appendChild(iframe);

                closeBtn = document.createElement("button");
                closeBtn.id = "chatbot-preview-close-btn";
                closeBtn.innerText = "✖";
                closeBtn.style.position = "fixed";
                closeBtn.style.top = "18px";
                closeBtn.style.right = "20px";
                closeBtn.style.color = "black";
                closeBtn.style.border = "none";
                closeBtn.style.borderRadius = "5px";
                closeBtn.style.fontSize = "16px";
                closeBtn.style.cursor = "pointer";
                closeBtn.style.zIndex = "10000";
                closeBtn.style.display = "block";
                document.body.appendChild(closeBtn);

                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                const script = document.createElement("script");
                script.src = ${JSON.stringify(window.__ENV__.ANALYTICS_CHATBOT_PLUGIN_URL)};
                script.async = true;

                const userConfigs = {
                    "third_party_token_provider": token_provider,
                    "third_party_token": third_party_token
                }

                const chatbotConfig = ${JSON.stringify(chatbotData)};

                const finalConfig = { ...chatbotConfig, ...userConfigs };
                script.onload = () => {
                    iframe.contentWindow.AmeayaChatBot?.("init", finalConfig);
                };

                iframeDoc.body.appendChild(script);
            };

            document.addEventListener("click", (event) => {
                if (event.target.id === "chatbot-preview-close-btn") {
                    handleCloseButton();
                }
            });
        }
        initChatbot();
    })()`
};

export const SimpleChatPreview = async (chatbotData) => {
    return `(
        function () {
            function initChatbot() {

            // Step 1: Remove existing iframe, background, and close button if present
            const IFRAME_ID = "ameya-simple-chatbot-iframe";
            const existingIframe = document.getElementById(IFRAME_ID);
            const existingBg = document.getElementById("ameya-chatbot-background");
            const existingCloseBtn = document.getElementById("ameya-chatbot-close-btn");
            if (existingIframe) existingIframe.remove();
            if (existingBg) existingBg.remove();
            if (existingCloseBtn) existingCloseBtn.remove();

            console.log("Chatbot ready to toggle...");

        window.toggleChatbot = (params = {}) => {

            const chatbotConfig = ${JSON.stringify(chatbotData)};

            let iframe = document.getElementById(IFRAME_ID);
            let bgOverlay = document.getElementById("ameya-chatbot-background");
            let closeBtn = document.getElementById("ameya-chatbot-close-btn");

            // Toggle if already open
            if (iframe && bgOverlay && closeBtn) {
                const isHidden = iframe.style.display === "none";
                iframe.style.display = isHidden ? "block" : "none";
                bgOverlay.style.display = isHidden ? "block" : "none";
                closeBtn.style.display = isHidden ? "block" : "none";
                return;
            }

            // background overlay
            bgOverlay = document.createElement("div");
            bgOverlay.id = "ameya-chatbot-background";
            bgOverlay.style.position = "fixed";
            bgOverlay.style.top = "0";
            bgOverlay.style.left = "0";
            bgOverlay.style.width = "100vw";
            bgOverlay.style.height = "100vh";
            bgOverlay.style.backgroundColor = "#FFFFFF";
            bgOverlay.style.zIndex = "9998";
            bgOverlay.style.display = "block";
            document.body.appendChild(bgOverlay);
            document.body.style.margin = "0";
            document.documentElement.style.margin = "0";

            // close (X) button
            closeBtn = document.createElement("button");
            closeBtn.id = "ameya-chatbot-close-btn";
            closeBtn.innerText = "✖";
            closeBtn.style.position = "fixed"; 
            closeBtn.style.top = "15px";
            closeBtn.style.left = "20px";
            closeBtn.style.color = "black";
            closeBtn.style.background = "white"; 
            closeBtn.style.border = "1px solid #ccc";
            closeBtn.style.borderRadius = "50%";
            closeBtn.style.width = "32px";
            closeBtn.style.height = "32px";
            closeBtn.style.fontSize = "16px";
            closeBtn.style.cursor = "pointer";
            closeBtn.style.zIndex = "10001"; 
            closeBtn.style.display = "flex";
            closeBtn.style.alignItems = "center";
            closeBtn.style.justifyContent = "center";
            closeBtn.style.boxShadow = "0 2px 5px rgba(0,0,0,0.2)";
            closeBtn.style.pointerEvents = "auto";
            document.body.appendChild(closeBtn);

            const closeChat = () => {
                iframe?.remove();
                bgOverlay?.remove();
                closeBtn?.remove();
                console.log("Chatbot closed.");
            };
            closeBtn.addEventListener("click", closeChat);

            iframe = document.createElement("iframe");
            iframe.id = IFRAME_ID;
            iframe.style.position = "fixed";
            iframe.style.bottom = "0.5rem";
            iframe.style.right = "1.5rem";
            iframe.style.width = "70px";
            iframe.style.height = "70px";
            iframe.style.border = "none";
            iframe.style.overflow = "hidden";
            iframe.style.margin = "0";
            iframe.style.padding = "0";
            iframe.style.zIndex = "9999";
            iframe.style.display = "block";
            iframe.style.boxSizing = "border-box";
            iframe.style.top = "auto";
            iframe.style.left = "auto";
            iframe.style.backgroundColor = "transparent";
            iframe.style.background = "transparent";
            iframe.setAttribute("allowTransparency", "true");
            document.body.appendChild(iframe);

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(\`
            <!DOCTYPE html>
                <html>
                    <head>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <style>
                            html, body {
                                margin: 0;
                                padding: 0;
                                height: 100%;
                                width: 100%;
                                overflow: hidden;
                                box-sizing: border-box;
                                display: flex;
                                flex-direction: column;
                                background-color: transparent !important;
                                background: transparent !important;
                            }
                            *, *::before, *::after {
                                box-sizing: inherit;
                            }
                            #root, #__next {
                                height: 100%;
                                width: 100%;
                                margin: 0;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                background: transparent !important;
                            }
                        </style>
                    </head>
                    <body>
                    </body>
                </html>
            \`);
            iframeDoc.close();

            // Step 7: Define destroy method
            iframe.contentWindow.parentDestroyChatbot = () => {
                console.log("Destroying chatbot iframe...");
                try {
                    iframe.contentWindow?.AmeayaChatBot?.("destroy");
                    iframe.remove();
                    bgOverlay.remove();
                    closeBtn.remove();
                    console.log("Chatbot iframe and background removed.");
                } catch (error) {
                    console.error("Error during chatbot destroy:", error);
                }
            };

            iframe.onload = () => {
                const script = iframeDoc.createElement("script");
                script.src = ${JSON.stringify(window.__ENV__.ANALYTICS_CHATBOT_PLUGIN_URL)}
                script.async = true;

                const userConfigs = {
                    "third_party_token_provider": null,
                    "third_party_token": null
                };
                const finalConfig = { ...${JSON.stringify(chatbotData)}, ...userConfigs };

                script.onload = () => {
                    iframe.contentWindow.AmeayaChatBot?.("init", finalConfig);
                    console.log("Chatbot initialized successfully inside iframe.");
                };

                iframeDoc.body.appendChild(script);
            };
        };

        console.log("window.toggleChatbot() is ready. Call it to open/close the chatbot.");

        if (window.toggleChatbot) {
            window.toggleChatbot();
        }
    }

    // Initialize once DOM is ready
    if (document.readyState === "complete" || document.readyState === "interactive") {
        initChatbot();
    } else {
        document.addEventListener("DOMContentLoaded", initChatbot);
    }
  })();
  `;
};
